import React from "react";
import { Dimmer, Loader, Segment } from "semantic-ui-react";

const LoadingComponent: React.FC<{ inverted?: boolean; content?: string }> = ({
  inverted = false,
  content,
}) => {
  return (
    <Segment >
      <Dimmer active inverted={inverted}>
        <Loader content={content} />
      </Dimmer>
    </Segment>
  );
};

export default LoadingComponent;
